import React, { useEffect, useState } from 'react';

import { ChevronUpIcon } from '@chakra-ui/icons';
import {
  Center,
  Container,
  Flex,
  IconButton,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { cockpitGet } from '../config/cockpit';
import { TextType } from '../models/Text';

import Text from './Text';

interface GlobalData {
  CompanyRegName?: string;
  CompanyTradingName?: string;
  CompanyRegAddress?: string;
}

const Footer = () => {
  const { t } = useTranslation();

  const [globalData, setGlobalData] =
    useState<GlobalData | null>(null);

  useEffect(() => {
    cockpitGet<GlobalData>(
      '/api/content/item/Global'
    )
      .then((data) => {
        setGlobalData(data);
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.error(
          'Failed to load company information:',
          err
        );

        setGlobalData(null);
      });
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <Container
      as="footer"
      bgColor="gray.700"
      paddingY="25px"
      minWidth="100%"
    >
      <Center>
        <Flex
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          width={{
            base: '100%',
            md: '80%',
          }}
          paddingX={{
            base: '20px',
            md: 0,
          }}
        >
          <IconButton
            variant="link"
            aria-label="Scroll to the top"
            icon={
              <ChevronUpIcon boxSize={50} />
            }
            color="white"
            size="md"
            onClick={handleScrollToTop}
          />

          <Text
            type={{
              base: TextType.Inter8Light,
              md: TextType.Inter10Light,
            }}
            color="white"
            others={{
              marginY: {
                base: '8px',
                md: '15px',
              },
              textAlign: 'center',
            }}
          >
            {t('footer.developedBy')}
          </Text>

          {globalData ? (
            <Text
              type={{
                base: TextType.Inter8Light,
                md: TextType.Inter10Light,
              }}
              color="white"
              others={{
                marginY: {
                  base: '8px',
                  md: '15px',
                },
                textAlign: 'center',
              }}
            >
              arch4d.co.uk is a website registered under{' '}
              {globalData.CompanyRegName || 'arch4D Limited'}
              {' - Company Nos: 12072714 registered in England '}
              with the following registration address:{' '}
              {globalData.CompanyRegAddress || ''}
            </Text>
          ) : null}

          <Flex
            alignItems="center"
            justifyContent="center"
            flexWrap="wrap"
            gap={{
              base: '12px',
              md: '24px',
            }}
            marginY={{
              base: '10px',
              md: '15px',
            }}
          >
            <Link to="/legals/privacy-policy">
              <Text
                type={{
                  base: TextType.Inter8Light,
                  md: TextType.Inter10Light,
                }}
                color="white"
                others={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Privacy Policy
              </Text>
            </Link>

            <Link to="/legals/cookie-policy">
              <Text
                type={{
                  base: TextType.Inter8Light,
                  md: TextType.Inter10Light,
                }}
                color="white"
                others={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Cookie Policy
              </Text>
            </Link>

            <Link to="/legals/terms-and-conditions">
              <Text
                type={{
                  base: TextType.Inter8Light,
                  md: TextType.Inter10Light,
                }}
                color="white"
                others={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Terms &amp; Conditions
              </Text>
            </Link>

            <Link to="/login">
              <Text
                type={{
                  base: TextType.Inter8Light,
                  md: TextType.Inter10Light,
                }}
                color="white"
                others={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Login
              </Text>
            </Link>
          </Flex>

          <Text
            type={{
              base: TextType.Inter10Light,
              md: TextType.Inter12Light,
            }}
            color="white"
            others={{
              marginY: {
                base: '8px',
                md: '15px',
              },
              textAlign: 'center',
            }}
          >
            © {globalData?.CompanyTradingName || 'arch4D'}{' '}
            {new Date().getFullYear()}
          </Text>
        </Flex>
      </Center>
    </Container>
  );
};

export default Footer;